/* src/app/components/admin/users/users.component.scss */
.user-search mat-form-field {
  height: 48px;
}
mat-form-field.custom-infix-padding {
  --padding-top: 22px;
  --padding-bottom: 8px;
}
/*# sourceMappingURL=users.component.css.map */
